//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatTrueFalse, formatSource, canDeleteSegment, getTagByKey } from './ReportMaterialsHelperFunctions.js'

export default {
  components: {
  },
  props: {
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    reportRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    items: {
      type: Array,
      default () {
        return []
      }
    },
    tags: {
      type: Array,
      default () {
        return []
      }
    },
    reportActionsAccess: {
      type: Object,
      default () {
        return {}
      }
    },
    displayRequestMaterialButton: {
      type: Boolean,
      default: false
    },
    showServiceObject: {
      type: Boolean,
      default: true
    },
    showTag: {
      type: Boolean,
      default: true
    },
    showRowFn: {
      type: Function,
      default () {
        return () => {
          return true
        }
      }
    },
    tableName: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      formatTrueFalse: formatTrueFalse,
      formatSource: formatSource,
      getTagByKey: getTagByKey,
      attributeReportMaterials: [
        { key: 'amount', name: 'Кол-во:' },
        { key: 'loops', name: 'Кол-во петель:' },
        { key: 'stockName', name: 'Склад:' },
        { key: 'sn', name: 'Серийный номер:' },
        { key: 'projectName', name: 'Проект:' },
        { key: 'serviceObjectName', name: 'Объект обслуживания:' },
        { key: 'df', name: 'Учёт в ДФ:' },
        { key: 'sourceTable', name: 'Источник:' },
        { key: 'tag', name: 'Тег:' },
        { key: 'comment', name: 'Комментарий исполнителя:' },
        { key: 'note', name: 'Замечание аналитика:' }
      ]
    }
  },
  methods: {
    canDeleteSegment: function () {
      return canDeleteSegment(this.report, this.tableName)
    },
    onDeleteItem: function (item) {
      this.$emit('delete-item', item)
    },
    onEditItem: function (item) {
      this.$emit('edit-item', item)
    },
    onRequestMaterial: function (item) {
      this.$emit('request-material', item)
    },
    getStyleItem: function (item) {
      if (item.noted === 'hasNotes') {
        return 'background-color: rgba(255,0,0,0.1); border: 1px solid red;'
      } else if (item.noted === 'noNotes') {
        return 'background-color: rgba(0,255,0,0.1); border: 1px solid green;'
      } else {
        return ''
      }
    },
    isShowAttribute: function (key, item) {
      let isShow = false
      const tags = this.tags
      switch (key) {
        case 'amount':
          isShow = true
          break
        case 'loops':
          isShow = item.hasLoops
          break
        case 'serviceObjectName':
          isShow = (item.serviceObjectName && this.showServiceObject)
          break
        case 'df':
          isShow = (item.df !== null && item.df !== undefined)
          break
        case 'tag':
          isShow = (item.tag && !!this.getTagByKey(item.tag, tags) && this.showTag)
          break
        case 'note':
          isShow = (item.noted === 'hasNotes' && item.note)
          break
        default:
          isShow = item[key]
          break
      }
      return isShow
    },
    getValueField: function (key, item) {
      let result = ''
      const tags = this.tags
      switch (key) {
        case 'amount':
          result = item.amount + item.unit
          break
        case 'df':
          result = this.formatTrueFalse(item.df)
          break
        case 'sourceTable':
          result = this.formatSource(item.sourceTable)
          break
        case 'tag':
          result = this.getTagByKey(item.tag, tags).name + ' (' + this.getTagByKey(item.tag, tags).description + ')'
          break
        default:
          result = item[key]
          break
      }
      return result
    }
  }
}
